import { ReactComponent as CENet } from './icon_cenet.svg';
import Icon, { IconProps } from './icon';

const IconCENet = (props: IconProps) => {
  return <Icon {...props} Svg={CENet} />;
};

export default IconCENet;
